function deepMerge(target, source) {
    const output = { ...target };
    if (target && typeof target === 'object' && source && typeof source === 'object') {
        for (const key in source) {
            if (source.hasOwnProperty(key)) {
                if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
                    if (!(key in target))
                        Object.assign(output, { [key]: source[key] });
                    else
                        output[key] = deepMerge(target[key], source[key]);
                } else if (Array.isArray(source[key]))
                    output[key] = Array.isArray(target[key]) ? [...target[key], ...source[key]] : source[key];
                else
                    Object.assign(output, { [key]: source[key] });
            }
        }
    }
    return output;
}

export default deepMerge;
